import SelectdDropDown from "../../../../components/DropDownComponent";
import DefaultModal from "../../CompanySettings/JobApproval/component/dialog";
import { ApprovalFlowGetData } from "../../CompanySettings/JobApproval/model/approvalsFlowModel";

interface ApprovalPopupProps {
  open: boolean;
  approvalFlows: ApprovalFlowGetData[];
  selectedId: string | null;
  onChange: (id: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export const ApprovalPopup: React.FC<ApprovalPopupProps> = ({
  open,
  approvalFlows,
  selectedId,
  onChange,
  onConfirm,
  onClose,
}) => {
  if (!open) return null;

  const hasFlows = approvalFlows.length > 0;
  const effectiveValue =
    selectedId ||
    (hasFlows
      ? String((approvalFlows.find((f) => f.is_default) ?? approvalFlows[0]).id)
      : "");

  return (
    <DefaultModal open={open} onClose={onClose}>
      <div className="p-4 space-y-4">
        <h3 className="text-lg font-semibold">Select Approval Flow</h3>

        {hasFlows ? (
          <SelectdDropDown
            id="approvalflow"
            label="Approval Flow"
            value={effectiveValue}
            options={approvalFlows.map((flow) => ({
              label: flow.name,
              value: String(flow.id),
            }))}
            onChange={(value) => onChange(String(value))}
          />
        ) : (
          <SelectdDropDown
            id="approvalflow"
            label="Approval Flow"
            value=""
            options={[{ label: "Default approval flow", value: "" }]}
            onChange={() => {}}
            
          />
        )}

        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-indigo-600 text-white rounded"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </DefaultModal>
  );
};
